import AbstractCommand from "../../../../../shared/src/ranj/app/core/AbstractCommand";
import SkinKeys from "../../../../../shared/src/ranj/app/ui/SkinKeys";
import GameModel from "../model/GameModel";
import GameStatus from "../model/GameStatus";
import SaveModel from "../model/SaveModel";


export default class StartGameCommand extends AbstractCommand {

    /**
     * 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveModel} saveModel 
     * @param {GameModel} gameModel 
     */
    constructor(dispatcher, saveModel, gameModel) {
        super(dispatcher);

        this.execute = function(event) {
            const saveGame = saveModel.getSaveGame();
            if (saveGame) {
                gameModel.applySnapshot(saveGame);
            }
            if (saveGame && (saveGame.status == GameStatus.FINISH || saveGame.status == GameStatus.END)) {
                this.gotoScreen(SkinKeys.END_SCREEN_SKIN);
            } else {
                this.gotoScreen(SkinKeys.GAME_SCREEN_SKIN);
            }
        };
    };

}